document.addEventListener('DOMContentLoaded', function() {
  var sections = document.querySelectorAll('.media-reviews-section');

  sections.forEach(function(container) {
    var sectionId = container.dataset.sectionId;

    var heading = container.querySelector('.media-reviews-heading');
    var defaultText = heading.getAttribute('data-default-text');

    var items = Array.prototype.slice.call(
      container.querySelectorAll('.media-review-item')
    );

    var isMobile = window.matchMedia('(max-width: 768px)').matches;

    function activateItem(item) {
      items.forEach(function(i) {
        i.classList.remove('active');
      });
      item.classList.add('active');
      heading.textContent = item.getAttribute('data-hover-text') || defaultText;
    }

    if (items.length > 0) {
      activateItem(items[0]);
    }

    items.forEach(function(item) {
      var evt = isMobile ? 'click' : 'mouseenter';
      item.addEventListener(evt, function() {
        activateItem(item);
      });
    });
  });
});
